/**
 * O calendário do mundo: de que ano é cada temporada.
 *
 * O motor não guarda data. Ele guarda temporada e rodada, que é o que a
 * simulação precisa, e o ano é derivado disto na hora de mostrar. O mundo não
 * tem relógio: a mesma semente dá o mesmo resultado hoje e daqui a dez anos, e
 * isso vale porque nada aqui pergunta as horas ao sistema.
 *
 * Esta conta vivia no cliente, dentro do formatador de data, e era o único
 * lugar que sabia que a temporada 1 é 2026. Ela subiu para cá quando o clube
 * criado passou a nascer no ano corrente: dois lugares sabendo o mesmo ano
 * dariam um clube fundado em 2026 aparecendo numa tela que chama o mesmo
 * momento de 2025.
 */
/**
 * O ano anterior ao da primeira temporada.
 *
 * A temporada 1 é 2026. O número é arbitrário e foi escolhido para a carreira
 * começar perto de quando o jogo começou a existir, que é o que faz "fundado em
 * 2026" significar alguma coisa para quem está jogando.
 */
export const ANO_DA_PRIMEIRA_TEMPORADA = 2026;
/** De que ano é aquela temporada. */
export function anoDaTemporada(temporada) {
    return ANO_DA_PRIMEIRA_TEMPORADA + temporada - 1;
}
//# sourceMappingURL=calendario.js.map